import { useEffect, useRef } from "react";

function useVersionChecker() {
  const currentVersion = useRef(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        console.log("currentversion.data",currentVersion.current)
        const res = await fetch('/version.json', { cache: 'no-cache' });
        const data = await res.json();
        if (!currentVersion.current) {
          currentVersion.current = data.version;
        } else if (currentVersion.current !== data.version) {
          window.location.reload(); // Force reload if version changed
        }
      } catch (err) {
        console.error('Version check failed:', err);
         window.location.reload();
      }
    };

    const interval = setInterval(checkVersion, 30000); // Check every 30 seconds
    return () => clearInterval(interval);
  }, []);
}

export default useVersionChecker;
